import { EarningsPage } from '@repo/ccc-main-app-lib/src/pages/EarningsPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/earnings')({
  component: UserEarningsPage,
})

function UserEarningsPage() {
  const { userId } = Route.useParams()

  return <EarningsPage userId={userId} />
}
